/**
 * Resolves the effective ID of a customizable library item (treatment, advice,
 * condition). A clinic or user override shadows the base record's ID.
 */
export const getId = (item: any): number => {
  return item?.userVersion || item?.clinicVersion || item?.ID;
};
